<script setup lang="ts">
import type { Question } from '../calendarQuestion'
import FlatButton from '@/components/atoms/FlatButton.vue'

const model = defineModel<Question[]>()

const addTextQuestion = () => {
  const newQuestion: Question = {
    type: 'TEXT',
    questionText: '',
    status: 'OPTIONAL',
  }

  if (!(model.value instanceof Array)) {
    model.value = [newQuestion]
  } else {
    model.value = [...model.value, newQuestion]
  }
}

const addSelectBoxQuestion = () => {
  const newQuestion: Question = {
    type: 'SELECT_BOX',
    questionText: '',
    status: 'OPTIONAL',
    options: ['', ''],
  }

  if (!(model.value instanceof Array)) {
    model.value = [newQuestion]
  } else {
    model.value = [...model.value, newQuestion]
  }
}
</script>

<template>
  <div :class="$style.navigation">
    <FlatButton @click="addTextQuestion">テキスト</FlatButton>
    <FlatButton @click="addSelectBoxQuestion">セレクトボックス</FlatButton>
  </div>
</template>

<style lang="scss" module>
.navigation {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tabsTrigger {
  flex: 1;
}
</style>
